import { useQuery } from "@apollo/client";
import { GET_CAMPAIGN_UPDATES } from "queries/hooks";
const SORT_VARIABLES = [
    { field: "IsPinned", direction: "Descending" },
    { field: "Recent", direction: "Descending" },
];
const useGetCampaignUpdates = ({ campaignId, limit = 3, }) => {
    var _a, _b;
    const { loading, error, fetchMore, data, } = useQuery(GET_CAMPAIGN_UPDATES, {
        variables: {
            campaignId,
            first: limit,
            sort: SORT_VARIABLES,
        },
        onError: (err) => {
            console.error(err);
        },
    });
    const loadMore = () => {
        fetchMore({
            variables: {
                after: data === null || data === void 0 ? void 0 : data.campaignUpdates.pageInfo.endCursor,
            },
        });
    };
    const updates = ((_a = data === null || data === void 0 ? void 0 : data.campaignUpdates.edges) !== null && _a !== void 0 ? _a : []).map((edge) => {
        var _a;
        return ({
            ...edge.node,
            reactions: (_a = edge.node.reactions) !== null && _a !== void 0 ? _a : [],
        });
    });
    return {
        updates,
        loadMore,
        hasNextPage: (_b = data === null || data === void 0 ? void 0 : data.campaignUpdates.pageInfo.hasNextPage) !== null && _b !== void 0 ? _b : false,
        loading,
        error,
    };
};
export default useGetCampaignUpdates;
